export const CONTENT_DOCUMENT_UPLOAD_TYPE = 'DOCUMENT_UPLOAD';
export const CONTENT_PURPOSE_ROWS = 100;
export const CONTENT_TYPE_ROOT_LEVEL = 1;
